import { formatUnits } from "@ethersproject/units";
import {
  PERCENT_DECIMALS,
  ProtocolInstance,
  ProtocolInstanceValue,
} from "@silo/types";
import { shiftDecimal } from "@silo/utils";
import { pipe } from "fp-ts/lib/function";

const PROTOCOL_SHARE_FEE: ProtocolInstanceValue<bigint> = {
  mainnetLegacy: 250_000_000_000_000_000n,
  mainnetLlama: 250_000_000_000_000_000n,
  mainnetGrand: 250_000_000_000_000_000n,
  arbitrum: 250_000_000_000_000_000n,
  optimism: 250_000_000_000_000_000n,
  base: 250_000_000_000_000_000n,
  lrtbase: 250_000_000_000_000_000n,
  anvil: 250_000_000_000_000_000n,
  local: 0n,
};

const ONE_HUNDRED_PERCENT = shiftDecimal(1n, PERCENT_DECIMALS);

export const adjustDepositApr = (
  depositApr: bigint,
  protocolInstance: ProtocolInstance
) => {
  const protocolShareFee = PROTOCOL_SHARE_FEE[protocolInstance];
  const consumerShare = ONE_HUNDRED_PERCENT - protocolShareFee;

  return shiftDecimal(consumerShare * depositApr, -PERCENT_DECIMALS);
};

export const adjustDepositAprNum = (
  depositApr: number,
  protocolInstance: ProtocolInstance
) => {
  const protocolShareFee = PROTOCOL_SHARE_FEE[protocolInstance];
  const consumerShare = pipe(
    ONE_HUNDRED_PERCENT - protocolShareFee,
    (bi) => formatUnits(bi, PERCENT_DECIMALS),
    Number
  );

  return consumerShare * depositApr;
};
